import { OverlayTrigger, Popover } from "react-bootstrap";

const FormatosDeIdentificaciones = () => {
  const popover = (
    <Popover id="popover-basic" style={{ maxWidth: "700px" }}>
      <Popover.Title as="h3">Formatos de Identificación</Popover.Title>
      <Popover.Content>
        <ul>
          <li>
            <strong>Persona Física Nacional:</strong> númerico de 9 dígitos
          </li>
          <li>
            <strong>Persona Jurídica:</strong> alfanumérico
          </li>
          <li>
            <strong>Residente Permanente:</strong> númerico de 17 dígitos
          </li>
          <li>
            <strong>Residente Temporal:</strong> númerico de 19 dígitos, con el
            formato ##########
            <strong>
              <span className="text-white bg-dark px-1">01</span>
            </strong>
            #######
          </li>
          <li>
            <strong>Asilado Político:</strong> númerico de 12 dígitos, con el
            formato ##
            <strong>
              <span className="text-white bg-dark px-1">9</span>
            </strong>
            #########
          </li>
          <li>
            <strong>Residente Permanente Libre de Condición:</strong>{" "}
            alfanúmerico de 17 caracteres, con el formato ###
            <strong>
              <span className="text-white bg-dark px-1">RE</span>
            </strong>
            ############
          </li>
          <li>
            <strong>Residente Rentista:</strong> númerico de 4 o 5 dígitos
          </li>
          <li>
            <strong>Refugiado:</strong> alfanúmerico hasta 15 caracteres, con el
            formato{" "}
            <strong>
              <span className="text-white bg-dark px-1">070</span>
            </strong>
            AAA######
          </li>
          <li>
            <strong>Persona Física Extranjera No Residente En El País:</strong>{" "}
            alfanumérico
          </li>
          <li>
            <strong>Documento Único:</strong> númerico de 12 dígitos
          </li>
          <li>
            <strong>Fideicomiso:</strong> númerico de 10 dígitos, con el formato
            #
            <strong>
              <span className="text-white bg-dark px-1">130</span>
            </strong>
            ######
          </li>
        </ul>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      trigger={["hover", "focus"]}
      placement="bottom"
      overlay={popover}
    >
      <span className="icon text-primary">
        <i className="fas fa-info-circle"></i>
      </span>
    </OverlayTrigger>
  );
};

export default FormatosDeIdentificaciones;
